import { useState, useEffect } from 'react';
import { getMostRecentScoringGroups } from '../offlineDb';

// Exposes the most-recently-cached tournament's scoring groups so the home
// page can offer an offline "Enter Scores" entry point even when there is no
// in-progress session yet. Re-reads when groups are (re)cached or the network
// state changes.
export function useCachedScoring() {
  const [cached, setCached] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const c = await getMostRecentScoringGroups();
        if (!cancelled) { setCached(c || null); setIsLoading(false); }
      } catch {
        if (!cancelled) { setCached(null); setIsLoading(false); }
      }
    };

    load();
    window.addEventListener('scoringGroupsCached', load);
    window.addEventListener('online', load);
    window.addEventListener('offline', load);
    return () => {
      cancelled = true;
      window.removeEventListener('scoringGroupsCached', load);
      window.removeEventListener('online', load);
      window.removeEventListener('offline', load);
    };
  }, []);

  const startedGroups = (cached?.groups || []).filter((g) => g.is_started);

  return {
    cachedScoring: cached,
    tournamentId: cached?.tournamentId ?? null,
    startedGroups,
    hasStartedGroups: startedGroups.length > 0,
    isLoading,
  };
}
